import { BaseModel } from '../base-model'
import { InsuranceProviderLookup, InsuranceProviderLookupData } from '../insurance-provider-lookup'
import { PayerGroup } from '../payer-group'
import { PortalData, PortalModel, PortalSystem } from '../portal'

export type AuthorizationRulesIssues = Record<string, AuthorizationRuleIssueDetails>

export interface AuthorizationRuleIssueDetails {
  lookupCount?: {
    expected: number
    actual: number
    createdAt: string
  }
}

export interface AuthorizationRuleData {
  id: string
  payerGroupIds: string[]
  payerGroups?: PayerGroup[]
  carrierLookups?: InsuranceProviderLookupData[]
  portalSystemId: string
  portals?: PortalData[]
  systemPortal: PortalSystem
  codes: string[]
  authorizationRequired: boolean
  referralRequired: boolean
  notes?: string
  issues?: AuthorizationRulesIssues
}

export const DEFAULT_AUTH_NECESSARY_CLINIC = 'MMX_AUTH_NECESSARY_CLINIC'

export class AuthorizationRule extends BaseModel {
  payerGroupIds: string[]
  payerGroups?: PayerGroup[]
  carrierLookups?: InsuranceProviderLookup[]
  portalSystemId: string
  portals?: PortalModel[]
  systemPortal: PortalSystem
  codes: string[]
  authorizationRequired: boolean
  referralRequired: boolean
  notes?: string
  issues?: AuthorizationRulesIssues

  constructor(data: AuthorizationRuleData) {
    super(data, true)

    if (data.payerGroups) {
      this.payerGroups = data.payerGroups.map((group) => new PayerGroup(group))
    }

    if (data.carrierLookups) {
      this.carrierLookups = data.carrierLookups.map((lookup) => new InsuranceProviderLookup(lookup))
    }

    if (data.portals) {
      this.portals = data.portals.map((portal) => new PortalModel(portal))
    }
  }

  public get formattedCodes(): string {
    if (!this.codes?.length) {
      return ''
    }

    if (this.codes.length <= 5) {
      return this.codes.join(', ')
    }

    return `${this.codes.slice(0, 4).join(', ')} ...${this.codes.length - 4} more`
  }

  public get isReadOnly(): boolean {
    return this.clinicId === DEFAULT_AUTH_NECESSARY_CLINIC
  }
}
